module.exports = __webpack_public_path__ + "img/apple.5c0cb40d.svg";